<template>
  <RfSimpleCard class="p-5!">
    <div class="m-px p-1">
      <RfSettingsTagsCreateModal
        ref="createTagModal"
        @create="tag => tagsStore.createTag(appsStore.app?.id, tag)"
      />

      <RfSettingsTagsEditModal
        v-if="editItem"
        ref="editTagModal"
        :tag="editItem"
        :currApp="appsStore.app"
        @edit="
          tag =>
            tagsStore.editTag(appsStore.app?.id, tag).then(() => editTagModal.closeEditTagModal())
        "
        @close="editItem = null"
      />

      <RfBaseModal
        v-if="deleteItem"
        ref="deleteModal"
        message="This cannot be undone."
        width="580"
        errorText="Delete"
        @error="submitDelete(deleteItem.id)"
        @close="deleteItem = null"
      >
        <template #title>
          Are you sure you want to delete
          <span class="font-bold whitespace-pre"> {{ deleteItem.title }} </span> ?
        </template>
      </RfBaseModal>
      <RfTable
        :tableData="tagsStore.table"
        class="rf-table"
        :rowSkeleton="RfSettingsTagsRowSkeleton"
        :loading="tagsStore.loading && !tagsStore.tags?.length"
        hideTotal
        @loadMore="() => tagsStore.loadTable(true)"
      >
        <template #thead>
          <RfSettingsTagsHeader :sort="sort" @update:sort="v => (sort = v)" />
        </template>
        <template #tbody>
          <template v-if="tagsStore.renderLength">
            <RfSettingsTagsRow
              v-for="i in tagsStore.renderLength"
              :key="`${tagsStore.tags[i - 1].id || tagsStore.tags[i - 1].title}`"
              :title="tagsStore.tags[i - 1].title"
              :description="tagsStore.tags[i - 1].description"
              :creator="tagsStore.tags[i - 1].creator_name"
              :color="tagsStore.tags[i - 1].color"
              :currApp="appsStore.app"
              @delete="
                () => ((deleteItem = tagsStore.tags[i - 1]), nextTick(() => deleteModal.show()))
              "
              @edit="
                () => (
                  (editItem = tagsStore.tags[i - 1]),
                  nextTick(() => editTagModal.showEditTagModal())
                )
              "
            />
          </template>
        </template>
      </RfTable>
    </div>
  </RfSimpleCard>
</template>

<script setup>
import RfSimpleCard from "@/components/RfSimpleCard.vue";
import { nextTick, onMounted, ref, watch } from "vue";
import { useTagsStore } from "@/pinia/tagsStore";
import RfTable from "@/blocks/RfTable/RfTable.vue";
import { useTableSort } from "@/utils/composables/useTableSort";
import RfBaseModal from "@/components/modals/RfBaseModal.vue";
import { useAppsStore } from "@/pinia/appsStore";
import RfSettingsTagsCreateModal from "./RfSettingsTagsCreateModal.vue";
import RfSettingsTagsEditModal from "./RfSettingsTagsEditModal.vue";
import RfSettingsTagsRow from "./RfSettingsTagsRow.vue";
import RfSettingsTagsHeader from "./RfSettingsTagsHeader.vue";
import RfSettingsTagsRowSkeleton from "./RfSettingsTagsRowSkeleton.vue";

const deleteItem = ref(null);
const editItem = ref(null);
const deleteModal = ref(null);
const createTagModal = ref();
const editTagModal = ref();
const tagsStore = useTagsStore();
const sort = useTableSort(["default"]);
const appsStore = useAppsStore();

const click = () => createTagModal.value?.show();
onMounted(() => tagsStore.getTags(appsStore.app?.id));

watch([sort], () => tagsStore.getTags(appsStore.app?.id), { deep: true });

const submitDelete = tagId => {
  tagsStore.deleteTag(appsStore.app?.id, tagId);
  deleteModal.value.close();
};

defineExpose({ click });
</script>
